import React from "react";
import CmruShell from "../../layouts/CmruShell";
import { appModules } from "../../components/global";
import { profile } from "../../components/CustomComponent";

// หน้าแรกของระบบ CMRU (โครงเริ่มต้น) หน้าถัดไปของระบบนี้ให้สร้างไว้ใน src/pages/cmru/
// แล้วเพิ่ม route ใต้ /cmru/ ใน routes.js และเมนูใน appGlobal.cmruMenu ของ global.js
export default function CmruWelcome() {
  const { title, description } = appModules["cmru_welcome"];
  const displayName = [profile?.employee?.first_name, profile?.employee?.last_name].filter(Boolean).join(" ") || profile?.full_name_th || profile?.email || "";

  return (
    <CmruShell title={title} description={description}>
      <div className="cmru-hero">
        <p className="cmru-hero-eyebrow">Chiang Mai Rajabhat University</p>
        <h1 className="cmru-hero-title">ยินดีต้อนรับ{displayName ? ` คุณ${displayName}` : ""}</h1>
        <p className="cmru-hero-text">
          คุณกำลังใช้งานระบบของมหาวิทยาลัยราชภัฏเชียงใหม่ ซึ่งแยกจากระบบบริหารองค์กรของ ParthenonTech
          สลับกลับได้จากตัวเลือกระบบใต้โลโก้ที่มุมซ้ายบน
        </p>
      </div>

      <div className="cmru-empty">
        <i className="fa-solid fa-seedling" />
        <div className="cmru-empty-title">ระบบกำลังอยู่ระหว่างวางโครง</div>
        <div className="cmru-empty-text">เมนูและฟังก์ชันของ CMRU จะทยอยเพิ่มเข้ามาที่นี่</div>
      </div>
    </CmruShell>
  );
}
